import { _ } from "core-js";
import session from "./session";
import gateway from "./gateway";

export default {
  fetchWebsiteDetails(id){
    return session.get(`/websites/details/${id}/`);
  },
  fetchSearchedDomains(data){
    let tlds = (data.tlds!==null)?`&tlds=${data.tlds.join(',')}`:``;
    return gateway.get(`/website-services/v1/domain-names/suggestions/?query=${data.domain}${tlds}`);
  },
  convertProductToWeb(id){
    return session.post(`/websites/${id}/actions/convert-to-2.0/`, '');
  },
  updateWebsiteDetails(id,data){
    return session.patch(`/websites/details/${id}/`, JSON.stringify(data));
  },
}
